import { render, staticRenderFns } from "./NonConformitiesTable.vue?vue&type=template&id=3ef65fab&scoped=true&"
import script from "./NonConformitiesTable.vue?vue&type=script&lang=js&"
export * from "./NonConformitiesTable.vue?vue&type=script&lang=js&"
import style0 from "./NonConformitiesTable.vue?vue&type=style&index=0&id=3ef65fab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef65fab",
  null
  
)

export default component.exports